import React, { useEffect } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import "./styles.scss";
import thankYouImage from "../../assets/images/thank-you.svg";
import Button from "../../components/primaryButton";
import PageHelmet from "../../components/pageHelmet";

function ThankYou({ history }) {
  useEffect(() => {
    window.gtag("event", "conversion", {
      send_to: "AW-999979137/uP5RCIbIipMDEIHx6dwD",
    });
  }, []);

  return (
    <>
      <PageHelmet title="Thank You" />
      <Header
        notHome={true}
        style={{
          background: `transparent linear-gradient(133deg, #ff9438 0%, #f12711 100%) 0%
      0% no-repeat`,
        }}
      />
      <div className="thank-you-component">
        <p className="thank-you-component-text1">Thank You!</p>
        <p className="thank-you-component-text2">
          for your interest in Value 360 Communications.
        </p>
        <div className="thank-you-component-image-container">
          <img src={thankYouImage} alt="Thank You" />
        </div>

        <p className="thank-you-component-text3">
          We will get in touch with you soon
        </p>
        <div className="thank-you-component-button-container">
          <Button
            onClick={() => history.push("/")}
            buttonName={"Back to homepage"}
            className="back-to-homepage-button"
          />
        </div>
        <div className="quries-contact thank-you-component-mobile">
          If you have any queries contact us at{" "}
          <a href="tel:+6531658101" className="tel-no">
            +6531658101
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ThankYou;
